document.addEventListener('DOMContentLoaded', () => {
    const partnersucheForms = document.querySelectorAll('.partnersuche-form');

    partnersucheForms.forEach(partnersucheForm => {
        partnersucheForm.noValidate = true;
        const getLang = function () {
            return document.documentElement.lang || "de";
        }

        const validatePartnersucheform = function (e) {
            e.preventDefault();
            const partnersuchePlz = partnersucheForm.querySelector('.partnersuche__location').value;
            const partnersucheMode = partnersucheForm.querySelector('.partnersuche__section').value;


            let msgPlz = 'Bitte geben Sie eine Postleitzahl an.';
            let msgMode = 'Bitte wählen Sie eine Dienstleistungskategorie aus.';


            if (getLang() === 'en') {
                msgPlz = 'Please enter a postal code.';
                msgMode = 'Please select a service category.';
            }

            let isValidPlz = partnersuchePlz ? true : msgPlz;
            let isValidMode = partnersucheMode ? true : msgMode;

            const errorContainer = document.getElementById('error-messages');

            if (errorContainer && (isValidPlz !== true || isValidMode !== true)) {
                //Filtert den Array ob true oder Error-Meldung
                let errors = [isValidPlz, isValidMode].filter(msg => msg !== true);
                errors = errors.map(err => `<p>${err}</p>`).join("");
                errorContainer.innerHTML = errors;
            } else {
                if (errorContainer) {
                    errorContainer.innerHTML = '';
                }
                // Mit dem URL-Objekt arbeiten
                const url = new URL(window.location.origin+partnersucheMode);
                url.searchParams.set("vpsearch", partnersuchePlz);

                window.location.href = url.toString();
            }
        }

        partnersucheForm.addEventListener('submit', validatePartnersucheform);
    })
});